/* util/servicenarhet-lager.js — VILKA service-täckytor som finns. Bara data.
 *
 * ⚠ Egen modul med FLIT. Tabellen behövs på tre ställen som laddas vid olika
 * tid: `ui/tile-fab.js` (bygger kryssrutorna vid uppstart), `ui/layer-legend.js`
 * (Aktiva lager-raderna) och `map/overlay-servicenarhet.js` (själva lagret, som
 * hämtas LAT först när någon tänder en ruta — state/lager-register.js). Låg
 * tabellen kvar i overlay-modulen skulle de två första dra in hela kartlagret i
 * startbundlen och lat-laddningen vore bortbyggd utan att någon märkte det.
 *
 * Tre strängar och tre tal per lager — ingen logik hör hemma här.
 *
 * ⚠ Titeln bär "· restid"/"· gångtid" sedan 2026-09-14: i Kartval stod
 * "Skola" två gånger (POI-prickarna och den här täckytan) med samma
 * kategori-tagg, och "Nyligen använda" kunde inte skilja dem åt. */

/* `min` = bandens minuttal, `profil` avgör vad de betyder: 'auto' = bil längs
 * vägnätet, 'pedestrian' = till fots. Skolor och förskolor mäts till fots för
 * att det är så en barnfamilj läser frågan; resten med bil, för det är så man
 * handlar och söker vård.
 *
 * `brandkar` finns med flit INTE här: brandstationernas täckyta är ett eget
 * lager med utryckningsprofil (~30 % snabbare framfart), och två motstridiga
 * brandtäckningar på samma karta vore värre än ingen. */
export const LAGER = [
    { slug: 'matbutiker',  titel: 'Matbutik · restid',    key: 'karta_servicenarhet_matbutiker',  profil: 'auto',       min: [5, 10, 15] },
    { slug: 'apotek',      titel: 'Apotek · restid',      key: 'karta_servicenarhet_apotek',      profil: 'auto',       min: [5, 10, 15] },
    { slug: 'vardcentral', titel: 'Vårdcentral · restid', key: 'karta_servicenarhet_vardcentral', profil: 'auto',       min: [5, 10, 15] },
    { slug: 'sjukhus',     titel: 'Sjukhus · restid',     key: 'karta_servicenarhet_sjukhus',     profil: 'auto',       min: [5, 10, 15] },
    { slug: 'bibliotek',   titel: 'Bibliotek · restid',   key: 'karta_servicenarhet_bibliotek',   profil: 'auto',       min: [5, 10, 15] },
    { slug: 'badhus',      titel: 'Badhus · restid',      key: 'karta_servicenarhet_badhus',      profil: 'auto',       min: [5, 10, 15] },
    { slug: 'tagstation',  titel: 'Tågstation · restid',  key: 'karta_servicenarhet_tagstation',  profil: 'auto',       min: [5, 10, 15] },
    { slug: 'laddstation', titel: 'Laddstation · restid', key: 'karta_servicenarhet_laddstation', profil: 'auto',       min: [5, 10, 15] },
    { slug: 'skola',       titel: 'Skola · gångtid',       key: 'karta_servicenarhet_skola',       profil: 'pedestrian', min: [10, 20, 30] },
    { slug: 'forskola',    titel: 'Förskola · gångtid',    key: 'karta_servicenarhet_forskola',    profil: 'pedestrian', min: [10, 20, 30] },
];

/* Bandens färger, närmast → längst. Sekventiell amber: ordningen bärs av
 * ljusheten, och legenden skriver ut minuterna, så färgen är aldrig ensam
 * kanal. Identisk med COVERAGE_BANDS i map/overlay-brandstation.js — samma
 * fråga, samma avläsning, och två olika amber-ramper för "inom N minuter"
 * hade bara sett ut som att de betydde olika saker. */
export const BANDS = [
    { band: 0, farg: '#d94801' },
    { band: 1, farg: '#fd8d3c' },
    { band: 2, farg: '#fdd0a2' },
];

/** MapLibre-lager-IDn för ett lager. EN ägare, så Aktiva lager och dimmern
 *  aldrig kan peka på ett ID som modulen döpt om. */
export function servicenarhetLagerIds(slug) {
    return [`mm-servicenarhet-${slug}-fill`, `mm-servicenarhet-${slug}-line`];
}
